import { useEffect } from "react";
import { useLocation } from "wouter";

const CANONICAL_ORIGIN = "https://aldersearch.com";

function normalisePath(pathname: string) {
  if (pathname === "/") return "/";
  return pathname.replace(/\/+$/, "");
}

export default function CanonicalUrl() {
  const [location] = useLocation();

  useEffect(() => {
    const canonicalHref = `${CANONICAL_ORIGIN}${normalisePath(location)}`;
    let canonical = document.querySelector<HTMLLinkElement>(
      'link[rel="canonical"]',
    );

    if (!canonical) {
      canonical = document.createElement("link");
      canonical.rel = "canonical";
      canonical.id = "canonical-url";
      document.head.appendChild(canonical);
    }

    canonical.href = canonicalHref;
  }, [location]);

  return null;
}
